import { Injectable } from '@angular/core';
// import { LoaderService } from './loader.service';  // Adjust paths as needed
import { PracticeService } from './practice.service';  // Adjust paths as needed
// import { SearchPatientReq } from './models/search-patient-req.model';  // Adjust paths as needed
import { Observable } from 'rxjs';
import { SearchPatientReq } from '../../model/v2/practice/searchPatientList';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(
    private loaderService: WindowLoaderService,
    private practiceService: PracticeService
  ) {}

  searchPatient(
    currentUserId: number,
    pageIndex: number,
    pageLength: number,
    searchCriteria: string
  ): Observable<any> {
    const searchReq: SearchPatientReq = new SearchPatientReq();
    searchReq.userId = currentUserId;
    searchReq.pageIndex = pageIndex;
    searchReq.itemsCount = pageLength;
    searchReq.criteria = searchCriteria;
    searchReq.parenttype = "employer";

    return new Observable(observer => {
      if (searchReq.userId) {
        this.loaderService.show();
        this.practiceService.getPractitionerPatientsList(searchReq).subscribe(
          (res) => {
            observer.next(res);
          },
          (error) => {
            observer.error(error);
            this.loaderService.hide();
          },
          () => {
            this.loaderService.hide();
            observer.complete();
          }
        );
      }
    });
  }
}
